<div class="root" *transloco="let t; read: 'formFieldOverbookingGrid'">
  <mat-form-field class="field">
    <mat-label>{{ t('overbookingGrid.timezone') }}</mat-label>
    <mat-select [formControl]="timezonePersonControl" (selectionChange)="changeTimeZone($event)">
      <mat-option *ngFor="let timezone of selectionTimezonePerson" [value]="timezone">
        {{ timezone | getTimeZoneTime }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <ng-container [formGroup]="parentFormGroup">
    <mat-form-field class="form-field">
      <crm-overbooking-grid-mat-input
        [placeholder]="field.name"
        [formControlName]="field.key"
        [required]="parentFormGroup.get(field.key).errors?.required"
        (slotSelected)="onSlotSelected($event)"
      ></crm-overbooking-grid-mat-input>

      <mat-error [ngxErrors]="field.key" #error="ngxErrors">
        <span ngxError="required">{{ t('overbookingGrid.requiredField') }}</span>
        <span ngxError="backend">{{ error.getError('backend') }}</span>
      </mat-error>
    </mat-form-field>
  </ng-container>
</div>
